export default [
    'English',
    'Malay',
    'Mandarin',
    'Cantonese',
    'Hokkien',
    'Tamil'
];
